import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

import Parse from "../../parse";

import { useGame } from "../header/GameContext";
import { getRanking } from "../../api/getRanking";
import { hasSurveyRow } from "../../api/surveyApi";

import Header from "../header/header";
import FooterButton from "../footer/footerButton";

import "./ranking.css";

export default function Ranking() {
  const navigate = useNavigate();

  const { TOTAL_GAME_TIME, playerKeyCode } = useGame();

  const [myRank, setMyRank] = useState(null);
  const [sorted, setSorted] = useState([]);
  const [hasSurvey, setHasSurvey] = useState(false);

  const userId = localStorage.getItem("gameUserId");

  useEffect(() => {
    const fetchRanking = async () => {
      const { sorted, myRank } = await getRanking(playerKeyCode);

      setSorted(sorted);
      setMyRank(myRank);
    };

    fetchRanking();
  }, [playerKeyCode]);

  // 설문 참여 여부 확인
  useEffect(() => {
    const checkSurvey = async () => {
      const result = await hasSurveyRow(userId);

      setHasSurvey(result);
    };

    if (userId) {
      checkSurvey();
    }
  }, [userId]);

  const handleFinish = () => {
    navigate("/survey/1");
  };

  return (
    <div id="content">
      <Header initialTime={TOTAL_GAME_TIME} missionCount={3} missionTotal={8} />

      <div className="box box_con con_box1 con_pd7 con_box_c ans0001">
        <div className="ranking_top">
          <div className="ranking_tit">
            <div className="icon-jelly"></div>
            <div className="t1">RANKING</div>
            <div className="t2">최우수 요원은 누구?</div>
          </div>
        </div>

        <div className="ranking_cont mt24">
          <ol className="ranking_list">
            {sorted.map((item, i) => (
              <li
                key={item.keyCode || i}
                className={item.keyCode === playerKeyCode ? "active" : ""}
              >
                {i + 1}등 {item.playerName}
              </li>
            ))}
          </ol>

          <p className="my-ranking mt40">내 순위 : {myRank}등</p>
        </div>

        {!hasSurvey && (
          <FooterButton
            ftIdName="box_ft"
            buttonClass="inputBtn02"
            buttonValue="체험 의견 전달하기"
            onFinish={handleFinish}
          />
        )}
      </div>
    </div>
  );
}
